import { render, staticRenderFns } from "./NewCustomSportsType.vue?vue&type=template&id=9511110e&"
import script from "./NewCustomSportsType.vue?vue&type=script&lang=js&"
export * from "./NewCustomSportsType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports